// extracted by mini-css-extract-plugin
export default {"followUpCell":"FollowUpCell_followUpCell__BuZEP","tooltipContent":"FollowUpCell_tooltipContent__c+BOr","infoIcon":"FollowUpCell_infoIcon__zGy1x"};